import { render, staticRenderFns } from "./additionAndDeletionOfStock.vue?vue&type=template&id=3fbc6bf7&scoped=true&"
import script from "./additionAndDeletionOfStock.vue?vue&type=script&lang=js&"
export * from "./additionAndDeletionOfStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fbc6bf7",
  null
  
)

export default component.exports